// absolute imports
import { useEffect, useState, useRef } from 'react';
import _debounce from 'lodash/debounce';

// Hook to return if window is active or not
export const useIsWindowFocused = () => {
  const [windowIsActive, setWindowIsActive] = useState(true);

  // debounced handler in ref to maintain same reference across renders
  const debouncedHandlerRef = useRef(
    _debounce(
      (e) => {
        if (e.type === 'focus') {
          return setWindowIsActive(true);
        }
        if (e.type === 'visibilitychange') {
          if (document.hidden) {
            return setWindowIsActive(false);
          }
          return setWindowIsActive(true);
        }
        return null;
      },
      100,
      { leading: false },
    ),
  );

  useEffect(() => {
    const debouncedHandler = debouncedHandlerRef.current;
    const handleActivity = (e) => {
      debouncedHandler(e);
    };

    document.addEventListener('visibilitychange', handleActivity);
    window.addEventListener('focus', handleActivity);
    document.addEventListener('focus', handleActivity);

    return () => {
      window.removeEventListener('focus', handleActivity);
      document.removeEventListener('focus', handleActivity);
      document.removeEventListener('visibilitychange', handleActivity);
      // Cancel any pending debounced calls on cleanup
      debouncedHandler.cancel();
    };
  }, []);

  return windowIsActive;
};

export default useIsWindowFocused;